export const regexExpressions = {
  password: {
    atLeast8Characters: /.{8,}/,
    oneLowercaseLetter: /[a-z]/,
    oneUppercaseLetter: /[A-Z]/,
    oneNumber: /\d/,
    oneSpecialCharacter: /[@$!%*?&]/,
  },
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  phoneNumber: /^\d{10}$/,
  numbers: /[^0-9]/g
};